import { z } from "zod";

import { consentReminderPopupSchema } from "./consentReminderPopup.schema";
import { discountDisclaimerSchema } from "./discountDisclaimer.schema";
import { generalConfigurationSchema } from "./generalConfiguration.schema";
import { loyaltySchema } from "./loyalty.schema";
import { orderSummaryConfigSchema } from "./orderSummaryConfig.schema";
import { shippingMethodSchema } from "./shippingMethod.schema";
import { sobSchema } from "./sob.schema";

export const checkoutConfigurationSchema = z.object({
  general: generalConfigurationSchema,
  shippingMethods: z.array(shippingMethodSchema).nullable().optional(),
  discountDisclaimer: discountDisclaimerSchema,
  consentReminderPopup: consentReminderPopupSchema,
  loyalty: loyaltySchema,
  orderSummaryConfig: orderSummaryConfigSchema,
  sob: sobSchema,
  fastFlowEnabled: z.boolean().optional(),
  taxInfo: z.object({
    message: z.string(),
    visible: z.boolean().optional(),
  }),
  ageVerificationPopup: z.object({
    description: z.string().optional(),
    successMessage: z.string().optional(),
  }),
  paymentFailed: z.object({
    message: z.string().optional(),
    title: z.string().optional(),
    retryPaymentButtonLabel: z.string().optional(),
  }),
  survey: z.object({
    identifier: z.string().optional(),
    domain: z.string().optional(),
  }),
  contact: z.object({
    differentRecipientDisabled: z.boolean().optional(),
    populatedPhoneInput: z.boolean().optional(),
  }),
  subscriptionTermsPlacement: z.enum(["sidebar", "consentAndPaySection"]).nullable().optional(),
  paymentFlow: z
    .object({
      isOrderPagePaymentFlowEnabled: z.boolean().optional(),
      orderWarningMessage: z.string().optional(),
    })
    .optional(),
  paymentSummaryConfig: z
    .object({
      isEnabledBackToCartButton: z.boolean().optional(),
    })
    .optional(),
});
